var map = {
	"./level-1.png": 15666,
	"./level-10.png": 9960,
	"./level-2.png": 30281,
	"./level-3.png": 52160,
	"./level-4.png": 3487,
	"./level-5.png": 6550,
	"./level-6.png": 20525,
	"./level-7.png": 66628,
	"./level-8.png": 10499,
	"./level-9.png": 62746
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 69528;